import { adPointDarkBlue } from "./colors";
import { createMuiTheme } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

export const createTheme = () => {
    return createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    padding: "8px",
                },
            },
            MuiIconButton: {
                root: {
                    padding: "4px",
                },
            },
        },
        typography: {
            fontSize: 12,
            allVariants: {
                letterSpacing: 0.25,
            },
        },
        palette: {
            primary: adPointDarkBlue,
            secondary: grey,
            error: {
                main: "#FF0000",
            },
        },
    });
};
